import type { CSSProperties } from 'react';
import '../components/atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../infrastructure/runtime';
import { useAppFit } from '../../hooks/useAppFit';
import { ScreenHeader } from '../components/atomic/layout/screen_header/ScreenHeader';
import { SkyAtmosphere } from '../components/composite/atmosphere/sky_atmosphere/SkyAtmosphere';
import type { ScreenViewProps } from '../shared/screenViewProps';
import decorLoadingImg from './decor_loading.png';
import decorLoading2Img from './decor_loading_2.png';
import type { LoadingScreenController } from './LoadingScreenController';
import type { LoadingScreenModel } from './LoadingScreenModelScreen';
import './loading_screen.css';
import { LoadingProgressBar } from './progress_bar/LoadingProgressBar';
import { HeaderText } from './texts/HeaderText';

export type LoadingScreenViewProps = ScreenViewProps<
  LoadingScreenModel,
  LoadingScreenController
>;

/** Loading screen (Figma concept 195:1286). */
export function LoadingScreenView({ model }: LoadingScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen loading-screen">
      <SkyAtmosphere variant="welcome" />
      <div
        className="loading-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <img
          className="loading-screen__decor"
          src={decorLoadingImg}
          alt=""
          draggable={false}
        />
        <img
          className="loading-screen__decor-2"
          src={decorLoading2Img}
          alt=""
          draggable={false}
        />
        <ScreenHeader showSubHeader={false} />
        <HeaderText />
        <LoadingProgressBar value={model.progress} />
      </div>
    </div>
  );
}
